import type { SvgIconProps } from 'types/icon';
import Home from '@mui/icons-material/Home';

export const HomeIcon = ({ color = 'inherit', ...props }: SvgIconProps) => (
  <Home color={color} {...props} />
);
